// ** Third party library
import SwiperCore, { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// ** Custom components
import LazyImg from "@components/lazy-load-image";

// ** Styles
import "@styles/react/libs/swiper/swiper.scss";
import { Container } from "reactstrap";

const params = {
  pagination: {
    clickable: true,
  },
};

SwiperCore.use([Pagination]);

const CarouselBanner = ({ slides, className, centerText }) => {
  return (
    <Swiper {...params}>
      {slides.map((item, idx) => (
        <SwiperSlide key={idx}>
          <div
            className={`carousel-banner__container ${
              className ? className : ""
            }`}
          >
            <div className="bg-gradient-overlay"></div>
            <LazyImg src={item.imgSrc} alt={item.title} className="fit-cover" />
            <Container
              className={`z-index-9 position-absolute top-50 translate-middle ${
                centerText
                  ? "position-absolute start-50 text-center  "
                  : "text-center text-lg-start start-50"
              }`}
            >
              {item.title && (
                <h1 className="text-white mb-2 display-6 fw-bolder">
                  {item.title}
                </h1>
              )}
              {item.desc && <h4 className="text-white">{item.desc}</h4>}
              {item.action && item.action}
            </Container>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default CarouselBanner;
